import React from "react";
import { navigate } from "@reach/router";
import { Box, Flex, Text } from "@theme-ui/components";
import { useBreakpointIndex } from "@theme-ui/match-media";
import { HeroSection } from "../molecules";
import { colors, typography } from "../../styles/theme";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { graphql, useStaticQuery } from "gatsby";

const ImageComponent = ({ imageKey, text, desc, customStyles }) => {

  const {
    featureImageIN1,
    featureImageIN2,
    featureImageIN3,
  } = useStaticQuery(graphql`
    query {
      featureImageIN1: file(relativePath: { eq: "homeV1/Countries.png" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, height: 60)
        }
      }
      featureImageIN2: file(relativePath: { eq: "homeV1/Companies.png" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, height: 60)
        }
      }
      featureImageIN3: file(relativePath: { eq: "homeV1/Users.png" }) {
        childImageSharp {
          gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, height: 60)
        }
      }
    }
  `);

  const imageMap = {
    featureIN1: featureImageIN1,
    featureIN2: featureImageIN2,
    featureIN3: featureImageIN3,
  };
  const image = getImage(imageMap[imageKey]);

  const imageComponentStyles = {
    p: "1.5rem",
    borderRadius: "1.25rem",
    alignItems: "center",
    "@media (max-width: 1042px)": {
      minWidth: "13.75rem",
    },
    ...customStyles,
  };

  return (
    <Flex sx={imageComponentStyles}>
      <GatsbyImage image={image} alt={text} />
      <Flex sx={{ flexDirection: "column", ml: "1rem", alignItems: "flex-start" }}>
        <Text as="h3" sx={{ ...typography.h3, mb: "0.5rem", textAlign: "start" }}>
          {text}
        </Text>
        <Text sx={{ ...typography.textMd500, textAlign: "start" }}>
          {desc}
        </Text>
      </Flex>
    </Flex>
  );
};

const CompanyStatistics = () => {
  return (
    <Flex sx={outerContainerStyles}>
      <ImageComponent imageKey="featureIN1"  text="25+" desc="Countries" customStyles={{ bg: "secondaryGreen100" }}/>
      <ImageComponent imageKey="featureIN2" text="30,000+" desc="Companies" customStyles={{ bg: "secondaryBlue100" }}/>
      <ImageComponent imageKey="featureIN3" text="30,00,000+" desc="Users" customStyles={{ bg: "secondaryOrange100" }}/>
    </Flex>
  );
};

const HeroBanner = ({ data }) => {
  const bp = useBreakpointIndex({ defaultIndex: 2 });
  const primaryCTA = (e) => {
    const gcName = bp < 2 ? "gc_2001_003" : "gc_2001_002";
    e.preventDefault();
    window.open(
      `/signup/?gc_name=${gcName}&gc_source=wgc%2F%home%2F&gc_index=0/`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <Box mx={["1.03rem", "1.03rem", "2rem", "3.12rem"]}>
      <HeroSection
        variant="media"
        tagColor={colors.secondaryOrange200}
        heading={
          <Text
            dangerouslySetInnerHTML={{ __html: data?.title }}
            sx={{ p: { m: 0 } }}
          />
        }
        subHeading={
          <Text
            dangerouslySetInnerHTML={{ __html: data?.description }}
            sx={{ p: { m: 0 } }}
          />
        }
        youtubeId={data?.videoId}
        thumbnailImage={data?.image}
        primaryBtnLabel="Start a greytHR Free Account"
        primaryBtnId="home_start_a_greythr_free_account_in_btn"
        secondaryBtnLabel="Talk to Us!"
        secondaryBtnId="home_talk_to_us_in_btn"
        onPrimaryBtnClick={primaryCTA}
        onSecondaryBtnClick={() => {
          window.open(
            '/demo/?gc_source=home&ac_form_tag=AF_DEMO_HOME',
            '_blank',
            'noopener,noreferrer'
          );
        }}        
      >
        <CompanyStatistics />
      </HeroSection>
    </Box>
  );
};

const { outerContainerStyles } = {
  outerContainerStyles: {
    mt: ["1.5rem", "1.5rem", "2rem", "3rem"],
    mb: ["1.5rem", "1.5rem", "2rem", "4rem"],
    flexWrap: "wrap",
    rowGap: "1.5rem",
    columnGap: ["2rem", "2rem", "4.5rem", "4.5rem"],
    flexDirection: ["column", "column", "row", "row"],
    justifyContent: "center",
    "@media (max-width:599px)": {
      maxWidth: "13.75rem",
      margin: "auto",
      my:"1.5rem"
    },
  },
};

export default HeroBanner;
